import React, { useCallback } from "react";
import { FieldProps } from "formik";
import { useDropzone } from "react-dropzone";
import { Button, Flex, Text } from "rebass";
import { toastr } from "react-redux-toastr";
import { MdCameraAlt } from "react-icons/md";

export function FilesFieldComponent(props: FieldProps) {
  const {
    field: { name, value },
    form: { setFieldValue, isSubmitting, },
  } = props;

  const onDropAccepted = useCallback(
    (files: Array<File>) => {
      const patch = files.filter(({ name }) => (
        value.every((file: File) => file.name !== name)
      ));

      setFieldValue(name, [...value, ...patch]);
    },
    [name, value, setFieldValue],
  );
  const onDropRejected = useCallback(
    (files: Array<File>) => {
      toastr.error("Something went wrong", "Invalid file type");
      console.log(files);
    },
    [],
  );

  const handleOnClick = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
    },
    []
  );

  const {
    getRootProps,
    getInputProps,
    open,
  } = useDropzone({
    accept: "image/*",
    onDropAccepted,
    onDropRejected,
    noDrag: true,
  });

  return (
    <div {...getRootProps({ onClick: handleOnClick })}>
      <input {...getInputProps()} />

      <Button
        type="button"
        width={1}
        px="18px"
        py="14.5px"
        borderRadius={0}
        color="zodiac"
        bg="#fff"
        disabled={isSubmitting}
        onClick={open}
      >
        <Flex
          justifyContent="space-between"
          alignItems="center"
        >
          <Text>
            Add a photo or file
          </Text>

          <MdCameraAlt display="block" size={26} />
        </Flex>
      </Button>
    </div>
  );
}
